import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import { Bell, User, LogOut, ChevronDown } from "lucide-react";
import { useSecurityContext } from "@/contexts/SecurityContext";
import { useAuth } from "@/contexts/AuthContext";
import conexLogo from "@/assets/conex-logo-large.png";

export function HeaderComponent() {
  const { userInfo } = useSecurityContext();
  const { logout } = useAuth();

  const name = userInfo
    ? `${userInfo.userFirstName} ${userInfo.userLastName}`.trim()
    : "";
  const initials = userInfo?.userInitials ?? "";

  // TODO: Replace with actual notification count from API/context when implemented
  const notificationCount = 0;

  return (
    <header className="h-16 w-full border-b border-border/40 glass-effect-strong bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-16 items-center justify-between px-6">
        <div className="flex items-center gap-4">
          <SidebarTrigger />
          <Separator orientation="vertical" className="h-6" />
          <div className="flex items-center gap-3">
            <img src={conexLogo} alt="Conex360" className="h-9 w-auto" />
          </div>
        </div>

        <div className="flex items-center gap-4">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="relative rounded-xl hover:bg-accent/60 transition-smooth"
                aria-label="Notifications"
              >
                <Bell className="h-5 w-5" />
                {notificationCount > 0 && (
                  <span className="absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-accent-vibrant ring-2 ring-background" />
                )}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="end"
              className="w-80 rounded-xl glass-effect shadow-xl"
            >
              <DropdownMenuLabel>Notifications</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <div className="p-4 text-center text-sm text-muted-foreground">
                No new notifications
              </div>
            </DropdownMenuContent>
          </DropdownMenu>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                className="flex items-center gap-3 pl-2 pr-2 h-11 rounded-xl hover:bg-accent/60 transition-smooth"
              >
                <div className="h-9 w-9 rounded-full bg-muted border border-border flex items-center justify-center overflow-hidden">
                  {initials ? (
                    <span className="text-sm font-semibold text-muted-foreground">{initials}</span>
                  ) : (
                    <User className="h-5 w-5 text-muted-foreground" />
                  )}
                </div>
                <div className="flex flex-col items-start text-sm hidden md:flex">
                  <span className="font-semibold leading-none">{name}</span>
                </div>
                <ChevronDown className="h-4 w-4 text-muted-foreground transition-transform duration-200 group-data-[state=open]:rotate-180" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="end"
              className="w-56 rounded-xl glass-effect shadow-xl"
            >
              <DropdownMenuLabel>
                <div className="flex flex-col space-y-1">
                  <p className="text-sm font-medium leading-none">
                    {name}
                  </p>
                  {userInfo?.userEmail && (
                    <p className="text-xs leading-none text-muted-foreground">
                      {userInfo.userEmail}
                    </p>
                  )}
                </div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className="text-destructive focus:text-destructive"
                onClick={() => logout()}
              >
                <LogOut className="mr-2 h-4 w-4" />
                <span>Sign out</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}

